import { formats, variations } from '../data/share';

export default function createRoutes(site) {
    const { brands = null, regions = null, locationTypes = null } = site;

    const brandsWithSlug = brands.filter(({ slug = null }) => slug !== null);
    const sections = brands.reduce(
        (allSections, { sections: brandSections = [] }) => [...allSections, ...brandSections],
        [],
    );

    const variationsSlugs = variations.map(({ id }) => id);

    const builtInSections = [
        'articles',
        'videos',
        'podcasts',
        'micromag',
        'populaire',
        'recent',
        'collections',
    ];

    const documentsTypes = [
        'article',
        'video',
        'micromag',
        'podcast',
        'concours',
        'interactif',
        'infolettre',
        'sondage',
    ];

    const brandPattern =
        brandsWithSlug.length > 0 ? brandsWithSlug.map(({ slug }) => slug).join('|') : null;
    const documentTypePattern = documentsTypes.join('|');
    const sectionsPattern = [...sections.map(({ slug }) => slug), ...builtInSections].join('|');
    const sectionsWildcardPattern = [
        ...sections.map(({ slug }) => slug),
        ...builtInSections,
        'abonner',
        'abonnement',
    ].join('|');

    return {
        'brand.wildcard':
            brandPattern !== null
                ? `/:brand(${brandPattern})?/:section(${sectionsWildcardPattern})?`
                : `/:section(${sectionsWildcardPattern})?`,

        home: brandPattern !== null ? `/:brand(${brandPattern})?` : '/',
        section:
            brandPattern !== null
                ? `/:brand(${brandPattern})?/:section(${sectionsPattern})`
                : `/:section(${sectionsPattern})`,

        'home.wildcard':
            brandPattern !== null
                ? `/:brand(${brandPattern})?/:section(${sectionsPattern})?`
                : `/:section(${sectionsPattern})?`,

        favicon: brandPattern !== null ? `/:brand(${brandPattern})?/favicon.png` : '/favicon.png',

        shareImage: brandPattern !== null ? `/:brand(${brandPattern})?/share.jpg` : '/share.jpg',

        menu: '/menu',
        search: '/recherche',

        subscription:
            brandPattern !== null ? `/:brand(${brandPattern})?/abonnement` : '/abonnement',

        subscribe: brandPattern !== null ? `/:brand(${brandPattern})?/abonner` : '/abonner',

        micromags: '/micromag',
        videos: brandPattern !== null ? `/:brand(${brandPattern})?/videos` : '/videos',
        articles: brandPattern !== null ? `/:brand(${brandPattern})?/articles` : '/articles',
        podcasts: brandPattern !== null ? `/:brand(${brandPattern})?/podcasts` : '/podcasts',
        popular: brandPattern !== null ? `/:brand(${brandPattern})?/populaire` : '/populaire',
        all: brandPattern !== null ? `/:brand(${brandPattern})?/recent` : '/recent',

        document: `/:type(${documentTypePattern})/:slug/:screen([^/.]+)?`,
        'document.share': `/:type(${documentTypePattern})/:slug/partage`,
        'document.share.wildcard': `/:type(${documentTypePattern})/:slug/partage/:path(.*)?`,
        'document.share_card': `/:type(${documentTypePattern})/:slug/partage/:variation(${variationsSlugs.join('|')})`,
        'document.share_image': `/:type(${documentTypePattern})/:slug/partage/:variation(${variationsSlugs.join('|')}).jpg`,
        article: '/article/:slug',
        contest: '/concours/:slug',
        video: '/video/:slug',
        interactive: '/interactif/:slug/:path([^/.]+)?',
        podcast: '/podcast/:slug',
        newsletter: '/infolettre/:slug',
        survey: '/sondage/:slug/:screen([^/.]+)?',
        micromag: '/micromag/:slug/:path([^/.]+)?',
        // micromag_screen: '/micromag/:slug/:screen',
        preview: '/preview/:token([^/]+)/:path([^/.]+)?',

        authors: '/auteurs',
        author: '/auteurs/:slug',

        collections:
            brandPattern !== null ? `/:brand(${brandPattern})?/collections` : '/collections',
        collection: '/collection/:slug',

        categories: '/categories',
        category: '/categorie/:slug',

        topics: '/sujets',
        topic: '/sujet/:slug',

        formats: '/formats',
        format: '/format/:slug',

        map: '/carte',
        'map.region':
            regions !== null && regions.length > 0
                ? `/carte/:region(${regions.map(({ slug }) => slug).join('|')})`
                : '/carte/:region',
        'map.location': '/carte/lieux/:location',
        'map.locationType':
            locationTypes !== null && locationTypes.length > 0
                ? `/carte/:locationType(${locationTypes.map(({ slug }) => slug).join('|')})`
                : '/carte/:locationType',
        'map.document': '/carte/contenu/:document',
        'map.wildcard': '/carte/:slug?/:subslug?',

        ai: '/ai/:slug',

        page: '/:slug',

        login: '/connexion',
        register: '/inscription',
        logout: '/deconnexion',
        'auth.wildcard': '/:slug(connexion|inscription|deconnexion)',

        account: '/compte',
        'account.profile': '/compte/profil',
        'account.subscriptions': '/compte/abonnements',
        'account.timeline': '/compte/historique',
        'account.wildcard': '/compte/:section?',
    };
}
